export const linesOfBusiness = [
    { name: 'LIFE', code: 'LIFE' },
    { name: 'ANNUITY', code: 'ANNUITY', disabled: true },
    { name: 'IDI', code: 'IDI', disabled: true },
    { name: 'WB', code: 'WB', disabled: true },
    { name: 'WSRS', code: 'WSRS', disabled: true }
];

export const productMappingLinesOfBusiness = [
    { name: 'LIFE', code: 'LIFE' },
    { name: 'ANNUITY', code: 'ANNUITY' },
    { name: 'IDI', code: 'IDI' },
    { name: 'WB', code: 'WB' },
    { name: 'WSRS', code: 'WSRS', disabled: true },
    { name: 'DMS', code: 'DISBURSEMENT' }
];

export const ALL_ACTIVE_BUSINESS_UNITS = ['LIFE'];
